/* IU Trust 1.1.4. Opens Shopify's existing consent UI; never grants consent. */
(() => {
  'use strict';
  let opening = false;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-iu-cookie-preferences]');
    if (!button || opening) return;
    const status = button.closest('nav, section')?.querySelector('[data-iu-cookie-status]');
    const message = (text) => {
      if (!status) return;
      status.textContent = text;
      status.hidden = !text;
    };
    opening = true;
    button.setAttribute('aria-busy', 'true');
    message('');
    try {
      if (typeof window.privacyBanner?.showPreferences !== 'function') {
        throw new Error('Native privacy banner unavailable');
      }
      await window.privacyBanner.showPreferences();
    } catch {
      message('Preferințele nu s-au putut deschide. Reîncarcă pagina și încearcă din nou.');
    } finally {
      opening = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
